import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type ObservableDocumentModel from './observable-document';
import { Type } from '@warp-drive/core-types/symbols';

export type LogSource = [
  'dispatch',
  'process',
  'validation_failed',
  'content_extracted',
  'dispute',
][number];

export default class ObservableDocumentLogModel extends Model {
  /*************************
   **  Attributes         **
   *************************/
  // TODO: type this
  @attr declare detail: { note: string; changes: { [key: string]: unknown } };
  // @attr declare logSource: (typeof LOG_SOURCE)[number];

  /*************************
   **  Relationships      **
   *************************/
  @belongsTo('observable-document', { async: false, inverse: 'observableDocumentLogs' })
  declare observableDocument: ObservableDocumentModel;

  [Type] = 'observable-document-log' as const;
}
